<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title>Volunteer</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
        <ion-card>
    <ion-card-content>
        <form-wizard title="Application Form" subtitle="Please fill in accurately" color="#1b9346">
        <tab-content title="Personal Information" :before-change="validateStep1">
           <form data-vv-scope="step-1">
            <ion-item id="rounded" lines="none">
                <ion-label position="floating">Full Name</ion-label>
                <ion-input name="full_name" v-validate="'required'" :value="new_volunteer.fullname" @ionInput="new_volunteer.fullname=$event.target.value"></ion-input>
            </ion-item>
            <p class="error" :force-show="errors.has('step-1.full_name')">{{ errors.first('step-1.full_name') }}</p>
            <ion-item id="rounded" lines="none">
                <ion-label position="floating">ID Number</ion-label>
                <ion-input name="id_number" v-validate="'required'" :value="new_volunteer.id_number" @ionInput="new_volunteer.id_number=$event.target.value"></ion-input>
            </ion-item>
            <p class="error" :force-show="errors.has('step-1.id_number')">{{ errors.first('step-1.id_number') }}</p>
            <ion-item id="rounded" lines="none">
                <ion-label position="floating">Mobile Number</ion-label>
                <ion-input name="mobile" v-validate="'required'" :value="new_volunteer.mobile_number" @ionInput="new_volunteer.mobile_number=$event.target.value"></ion-input>
            </ion-item>
            <p class="error" :force-show="errors.has('step-1.mobile')">{{ errors.first('step-1.mobile') }}</p>
            <ion-item id="rounded" lines="none">
                <ion-label position="floating">Email</ion-label>
                <ion-input name="email" v-validate="'required'" :value="new_volunteer.email" @ionInput="new_volunteer.email=$event.target.value"></ion-input>
            </ion-item>
            <p class="error" :force-show="errors.has('step-1.email')">{{ errors.first('step-1.email') }}</p>
            <ion-item>
                <ion-label>Gender</ion-label>
                <ion-select name="gender" v-validate="'required'" :value="new_volunteer.gender" @ionChange="new_volunteer.gender=$event.target.value" placeholder="Select One">
                    <ion-select-option>Female</ion-select-option>
                    <ion-select-option>Male</ion-select-option>
                    <ion-select-option>Other</ion-select-option>
                </ion-select>
            </ion-item>
            <p class="error" :force-show="errors.has('step-1.gender')">{{ errors.first('step-1.gender') }}</p>
            <ion-item>
                <ion-label>Race</ion-label>
                <ion-select name="race" v-validate="'required'" :value="new_volunteer.race" @ionChange="new_volunteer.race=$event.target.value" placeholder="Select One">
                    <ion-select-option>Black</ion-select-option>
                    <ion-select-option>White</ion-select-option>
                    <ion-select-option>Indian</ion-select-option>
                    <ion-select-option>Coloured</ion-select-option>
                    <ion-select-option>Asian</ion-select-option>
                    <ion-select-option>Other</ion-select-option>
                </ion-select>
            </ion-item>
            <p class="error" :force-show="errors.has('step-1.race')">{{ errors.first('step-1.race') }}</p>
            <ion-item>
                <ion-label>Language</ion-label>
                <ion-select name="language" v-validate="'required'" :value="new_volunteer.language" @ionChange="new_volunteer.language=$event.target.value" placeholder="Select One">
                    <ion-select-option>isiZulu</ion-select-option>
                    <ion-select-option>isiXhosa</ion-select-option>
                    <ion-select-option>Afrikaans</ion-select-option>
                    <ion-select-option>English</ion-select-option>
                    <ion-select-option>Sesotho</ion-select-option>
                    <ion-select-option>Setswana</ion-select-option>
                    <ion-select-option>Xitsonga</ion-select-option>
                    <ion-select-option>Tshivenḓa</ion-select-option>
                    <ion-select-option>isiNdebele</ion-select-option>
                    <ion-select-option>Other</ion-select-option>
                </ion-select>
            </ion-item>
            <p class="error" :force-show="errors.has('step-1.language')">{{ errors.first('step-1.language') }}</p>
            <ion-item>
                <ion-label>Disability?</ion-label>
                <ion-select name="disability" v-validate="'required'" :value="new_volunteer.disability" @ionChange="new_volunteer.disability=$event.target.value" placeholder="Select One">
                    <ion-select-option>Yes</ion-select-option>
                    <ion-select-option>No</ion-select-option>
                </ion-select>
            </ion-item>
            <p class="error" :force-show="errors.has('step-1.disability')">{{ errors.first('step-1.disability') }}</p>
            <ion-item>
                <ion-label>Criminal record?</ion-label>
                <ion-select name="record" v-validate="'required'" :value="new_volunteer.criminal_record" @ionChange="new_volunteer.criminal_record=$event.target.value" placeholder="Select One">
                    <ion-select-option>Yes</ion-select-option>
                    <ion-select-option>No</ion-select-option>
                </ion-select>
            </ion-item>
            <p class="error" :force-show="errors.has('step-1.record')">{{ errors.first('step-1.record') }}</p>
            <!--<ion-button @click="submitForm" expand="full">Submit</ion-button>-->
        </form>
        </tab-content>
        <tab-content title="Qualifications" :before-change="validateStep2">
            <form data-vv-scope="step-2">
                <h5>Qualifications</h5>
                <ion-card v-for="(qual,index) in new_volunteer.qualifications" :key="index+'-qual'" style="margin:0;margin-bottom:4px;margin-top:4px">
                    <ion-item>
                    <ion-label>Qualification</ion-label>
                    <ion-button @click="removeQualification(index)" slot="end">Remove</ion-button>
                    </ion-item>

                    <ion-card-content>
                        <ion-item id="rounded" lines="none">
                            <ion-label position="floating">Name Of Institution</ion-label>
                            <ion-input name="institution" v-validate="'required'" :value="qual.institution" @ionInput="qual.institution=$event.target.value"></ion-input>
                        </ion-item>
                        <p class="error" :force-show="errors.has('step-2.institution')">{{ errors.first('step-2.institution') }}</p>
                        <ion-item id="rounded" lines="none">
                            <ion-label position="floating">Name Of Qualification</ion-label>
                            <ion-input name="qualification" v-validate="'required'" :value="qual.qualification" @ionInput="qual.qualification=$event.target.value"></ion-input>
                        </ion-item>
                        <p class="error" :force-show="errors.has('step-2.qualification')">{{ errors.first('step-2.qualification') }}</p>
                        <ion-item id="rounded" lines="none">
                            <ion-label position="floating">Year Obtained</ion-label>
                            <ion-input name="obtained" v-validate="'required'" :value="qual.year_obtained" @ionInput="qual.year_obtained=$event.target.value"></ion-input>
                        </ion-item>
                        <p class="error" :force-show="errors.has('step-2.obtained')">{{ errors.first('step-2.obtained') }}</p>
                    </ion-card-content>
                </ion-card>
                <ion-button @click="addQualification" size="small">Add Qualification</ion-button>
                <h5>Work Experience</h5>
                <ion-card v-for="(exp,index) in new_volunteer.experiences" :key="index+'-exp'" style="margin:0;margin-bottom:4px;margin-top:4px">
                    <ion-item>
                    <ion-label>Experience</ion-label>
                    <ion-button @click="removeExperience(index)" slot="end">Remove</ion-button>
                    </ion-item>

                    <ion-card-content>
                        <ion-item id="rounded" lines="none">
                            <ion-label position="floating">Employer</ion-label>
                            <ion-input name="employer" v-validate="'required'" :value="exp.employer" @ionInput="exp.employer=$event.target.value"></ion-input>
                        </ion-item>
                        <p class="error" :force-show="errors.has('step-2.employer')">{{ errors.first('step-2.employer') }}</p>
                        <ion-item id="rounded" lines="none">
                            <ion-label position="floating">Position</ion-label>
                            <ion-input name="position" v-validate="'required'" :value="exp.position_title" @ionInput="exp.position_title=$event.target.value"></ion-input>
                        </ion-item>
                        <p class="error" :force-show="errors.has('step-2.position')">{{ errors.first('step-2.position') }}</p>
                        <ion-item id="rounded" lines="none">
                            <ion-label position="floating">Reason for leaving</ion-label>
                            <ion-input name="reason" v-validate="'required'" :value="exp.reason_for_leaving" @ionInput="exp.reason_for_leaving=$event.target.value"></ion-input>
                        </ion-item>
                        <p class="error" :force-show="errors.has('step-2.reason')">{{ errors.first('step-2.reason') }}</p>
                    </ion-card-content>
                </ion-card>
                <ion-button @click="addExperience" size="small">Add Experience</ion-button>
            </form>
        </tab-content>
        <tab-content title="Declaration">
            <form data-vv-scope="step-3">
                <h5>References</h5>
                <ion-card v-for="(ref,index) in new_volunteer.references" :key="index+'-ref'" style="margin:0;margin-bottom:4px;margin-top:4px">
                    <ion-item>
                    <ion-label>Reference</ion-label>
                    <ion-button @click="removeReference(index)" slot="end">Remove</ion-button>
                    </ion-item>

                    <ion-card-content>
                        <ion-item id="rounded" lines="none">
                            <ion-label position="floating">Name</ion-label>
                            <ion-input name="reference" v-validate="'required'" :value="ref.fullname" @ionInput="ref.fullname=$event.target.value"></ion-input>
                        </ion-item>
                        <p class="error" :force-show="errors.has('step-3.reference')">{{ errors.first('step-3.reference') }}</p>
                        <ion-item id="rounded" lines="none">
                            <ion-label position="floating">Relationship to you</ion-label>
                            <ion-input name="relationship" v-validate="'required'" :value="ref.relationship" @ionInput="ref.relationship=$event.target.value"></ion-input>
                        </ion-item>
                        <p class="error" :force-show="errors.has('step-3.relationship')">{{ errors.first('step-3.relationship') }}</p>
                        <ion-item id="rounded" lines="none">
                            <ion-label position="floating">Tel</ion-label>
                            <ion-input name="tel" v-validate="'required'" :value="ref.tel" @ionInput="ref.tel=$event.target.value"></ion-input>
                        </ion-item>
                        <p class="error" :force-show="errors.has('step-3.tel')">{{ errors.first('step-3.tel') }}</p>
                    </ion-card-content>
                </ion-card>
                <ion-button @click="addReference" size="small">Add Reference</ion-button>
                <h5>Upload your CV:</h5>
                <vue-dropzone ref="myVueDropzone" id="dropzone"
                    class="mydropzone"
                    :awss3="awss3"
                    :options="dropzoneOptions"
                    v-on:vdropzone-success="generalCVSuccess"></vue-dropzone>
                <br/>
                <h5>Upload a signed Z83 Form:</h5>
                <vue-dropzone ref="myVueDropzone2" id="dropzone2"
                    class="mydropzone"
                    :awss3="awss3"
                    :options="dropzoneOptions"
                    v-on:vdropzone-success="generalZ83Success"></vue-dropzone>
            </form>
            <br/>
            I declare that all the information provided (including any attachments) is complete and correct to the best of my knowledge. I understand that any false information supplied could lead to my application being disqualified or my discharge if I am appointed:
        </tab-content>
        <template slot="footer" slot-scope="props">
        <div class="wizard-footer-left no-float">
            <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab()" class="no-float" :style="props.fillButtonStyle">Previous</wizard-button>
            </div>
            <div class="wizard-footer-right no-float">
            <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right no-float" :style="props.fillButtonStyle">Next</wizard-button>

            <wizard-button v-else @click.native="saveVolunteer" class="wizard-footer-right no-float" :style="props.fillButtonStyle">{{props.isLastStep ? 'Submit' : 'Next'}}</wizard-button>
            </div>
        </template>
        </form-wizard>
      
    </ion-card-content>
  </ion-card>
        
    </ion-content>
  </ion-page>
</template>

<script>
import Modal from './ResultsModal';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
export default {
    name:'volunteer',
    components:{
        vueDropzone: vue2Dropzone
    },
    data(){
        return {
            new_volunteer:{
                fullname:'',
                ref:'',
                id_number:'',
                email:'',
                mobile_number:'',
                gender:'Female',
                race:'Black',
                language:'isiZulu',
                disability:"No",
                criminal_record:"No",
                status:'PROCESSING',
                status_reason:'PROCESSING',
                documents:[],
                qualifications:[{
                    qualification:'',
                    institution:'',
                    year_obtained:''
                },],
                experiences:[{
                    employer:'',
                    position_title:'',
                    reason_for_leaving:''
                },],
                references:[{
                    fullname:'',
                    relationship:'',
                    tel:''
                },]
            },
            dropzoneOptions: {
                url:'#',
                thumbnailWidth: 150,
                maxFilesize: 0.5,
                maxFiles:1,
                addRemoveLinks: true,
            },
            awss3: {
                signingURL: (f)=>{ return this.$store.get('base_url')+'/api/volunteers/upload/signed/'+f.name},
                headers: {},
                params : {},
                sendFileToServer : false,
                withCredentials: false
            },
        }
    },
    methods:{
        showModal(){
            return this.$ionic.modalController.create(
                {
                    component:Modal,
                    componentProps:{
                        propsData:{
                            title:'Volunteer',
                            message:'Thank you for pledging your support, your application is being processed. You will be contacted with further instructions',
                            closeMe: () => {
                                this.$ionic.modalController.dismiss()
                            },
                            result:'success'
                        }
                    }
                }
            ).then(m=>m.present());
        },
        addQualification(){
            this.new_volunteer.qualifications.push({
                    qualification:'',
                    institution:'',
                    year_obtained:''
                });
        },
        removeQualification(index){
            this.new_volunteer.qualifications.splice(index,1);
        },
        addExperience(){
            this.new_volunteer.experiences.push({
                    employer:'',
                    position_title:'',
                    reason_for_leaving:''
                });
        },
        removeExperience(index){
            this.new_volunteer.experiences.splice(index,1);
        },
        addReference(){
            this.new_volunteer.references.push({
                    fullname:'',
                    relationship:'',
                    tel:''
                });
        },
        removeReference(index){
            this.new_volunteer.references.splice(index,1);
        },
        generalCVSuccess(file,response){
            console.log(response);
            this.new_volunteer.documents.push({
                file_name:file.name,
                file_type:file.type,
                file_size:file.size,
                file_url:file.s3Signature.key,
                doc_type:'CV'
            })
        },
        generalZ83Success(file,response){
            console.log(response);
            this.new_volunteer.documents.push({
                file_name:file.name,
                file_type:file.type,
                file_size:file.size,
                file_url:file.s3Signature.key,
                doc_type:'Z83'
            })
        },
        submitForm(){
            this.$validator.validateAll().then((res)=>res && this.saveVolunteer());
        },
        validateForm(scope){
            return this.$validator.validateAll(scope);
        },
        validateStep1(){
            return this.validateForm('step-1');
        },
        validateStep2(){
            return this.validateForm('step-2');
        },
        saveVolunteer(){
            //save and show modal
            return this.$ionic.loadingController
            .create({
            message: 'Please wait...',
            })
            .then(loading => {
                loading.present();
                const base_url=this.$store.get('base_url');
                this.$http.post(base_url+'/api/volunteers/',this.new_volunteer)
                .then((res)=>console.log(res))
                .then(()=>loading.dismiss())
                .then(()=>this.showModal())
                .catch((err)=>{loading.dismiss();this.showModal();console.log(err)});
            })
        }
    }
}
</script>

<style scoped>
ion-toolbar {
  --ion-toolbar-background:#fbc414;
  --ion-text-color:white;
}
ion-back-button{
    --color:white;
}
ion-button{
    --background:#1b9346;
}
#rounded{
    --border-color: #d2d2d2;
  --border-radius: 10px;
  --border-width: 1px;
  --box-shadow: 2px gray;
  --highlight-height: 0;
  --background: #f8f9fa;
  margin: 10px;
  margin-left: 0px;
  margin-right: 0px;
}
.error{
  padding-left: 10px;
  text-transform: uppercase;
  color: red;
  font-size: 0.7em;
}
.no-float{
    float: none !important;
    display: block;
    width: 100%;
    margin-bottom: 4px;
}
.wizard-footer-left{
    float: none;
}
#qcards{
    margin: 0;
    margin-bottom: 2px;
    margin-top: 2px;
}
.mydropzone{
    text-align: center;
    border: 1px dashed #dadfe4;
    padding: .75rem;
    position: relative;
    border-radius: .375rem;
    will-change: border-color,background;
    min-height: 100px;
    -webkit-transition: border-color .25s ease-in-out,background .25s ease-in-out;
    transition: border-color .25s ease-in-out,background .25s ease-in-out;
}
.dropzone-wrapper{
    padding: .75rem 1.0625rem!important;
}
</style>